var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"combinations-warning"},[_c('div',{staticClass:"combinations-warning__content"},[_c('p',{staticClass:"combinations-warning__text"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }